module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/dk-c2e570fa503242ab4c3edca6b2acb2cb.svg";